import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "@firebase/auth";
import { UserAuthContext } from "../../App";
import { getStoresApi } from "../../Apis/StoreApi";
import { createInquiryApi } from "../../Apis/EnquiryApi";

import { userProfileDetailsApi } from "../../Apis/UserApi";
import { allProductByTagsAPI, allProductIdApi } from "../../Apis/ProductApi";
import WebStoreProducts from "./WebStoreProducts";

const BestDealsSection = ({onTopInclude}) => {
  const auth = getAuth();
  const { userUid } = useContext(UserAuthContext);
  const [allProductsData, setAllProductsData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [storeDetails, setStoreDetails] = useState({});

  const [showForm2, setShowForm2] = useState(false);
  const [showForm3, setShowForm3] = useState(false);
  const navigate = useNavigate(); // Add this line to use the useNavigate hook

  // fetch all Products by the tags
  // const getProductsData = async () => {
  //   try {
  //     const response = await allProductByTagsAPI("top");
  //     if (response?.products?.length > 0) {
  //       setAllProductsData(response.products.slice(0, 2));
  //       await getStoreDetails(response.products?.storeID);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //   }
  // };

  // useEffect(() => {
  //   getProductsData();
  // }, []);

  // const [userData, setUserData] = useState({
  //   uid: "",
  //   name: "",
  //   email: "",
  //   phone: "",
  //   billingAddress: "",
  //   accountType: "",
  //   gstNumber: "",
  //   storeName: "",
  //   country: "",
  // });

  const [inquiryContact, setInquiryContact] = useState(
    userUid?.currentUser?.uid ? userUid?.currentUser?.phoneNumber : ""
  );
  const [inquiryEmail, setInquiryEmail] = useState(
    userUid?.currentUser?.uid ? userUid?.currentUser?.email : ""
  );
  const [inquiryContent, setInquiryContent] = useState("");
  const [inquiryQuantity, setInquiryQuantity] = useState("");

  // // fetch user / buyer details
  // const fetchUserDetails = async () => {
  //   try {
  //     const response = await userProfileDetailsApi(userUid?.currentUser?.uid);
  //     setUserData({
  //       uid: userUid?.currentUser?.uid,
  //       name: userUid?.currentUser?.displayName,
  //       email: userUid?.currentUser?.email,
  //       billingAddress: response?.userData?.billingAddress,
  //       phone: response?.userData?.phoneNumber,
  //       accountType: response?.userData?.accountType,
  //       gstNumber: response?.userData?.gstNumber,
  //       storeName: response?.userData?.storeName,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching user details:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchUserDetails();
  // }, [userUid?.currentUser?.uid]);

  const getStoreDetails = async (storeID) => {
    try {
      const storeResponse = await getStoresApi(storeID);
      if (storeResponse && storeResponse?.store) {
        setStoreDetails(storeResponse.store);
      } else {
        console.error("Error fetching store details:", storeResponse);
      }
    } catch (error) {
      console.error("Error fetching store details:", error);
    }
  };

  // ... rest of your component code ...

  const handleViewAllInquiries = () => {
    navigate("/orders/inquiry"); // Redirect to inquiries page
  };

  const toggleNextButton = () => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    setShowForm2(true);
    setShowForm3(false);
  };

  const toggleSubmitButton = async () => {
    // alert(selectedProduct?.productID);
    await createInquiryApi(
      selectedProduct.productID,
      userUid?.currentUser?.uid,
      selectedProduct.storeID,
      inquiryContact,
      inquiryQuantity,
      inquiryEmail,
      inquiryContent
    );
    setShowForm2(false);
    setShowForm3(true);

    setInquiryContact("");
    setInquiryQuantity("");
    setInquiryEmail("");
    setInquiryContent("");
  };

  const toggleBackToProductButton = () => {
    setShowForm2(false);
    setShowForm3(false);
  };

  return (
    <>
    <div className="w-full bg-white">
      <div className="container max-w-[1240px] mx-auto w-full h-[410px] flex flex-col pt-[4px]">
        <h3 className="w-[171px] h-[27px] font-semibold text-[18px] text-black text-start">
          Today’s Best Deals
        </h3>
        <hr className="w-[228px] h-[3px] bg-[#FF6300] text-start mt-[8px]" />
        {/* {deals.map((products)=>{ */}
        <div className="w-full h-[316px] flex flex-row items-center justify-between mt-[20px]">
          <div className="w-[610px] h-[316px] bg-white rounded-[10px] flex flex-row p-[20px] border gap-x-[22px]">
            <div className="flex flex-col w-[228px] h-full">
              <p className="w-[59px] h-[27px] bg-[#FF6300] rounded-[5px] flex items-center justify-center text-center font-semibold text-white text-[15px]">
                New
              </p>
              <div className="flex items-center justify-center w-full h-full">
                <img
                  src={require("../../assets/WebFront/BestDeal/image 244.png")}
                  alt=""
                  className="w-[198px] h-[198px]"
                />
              </div>
            </div>

            <div className="flex flex-col">
              <h2 className="w-[239px] h-[27px] text-start text-black font-semibold text-[18px]">
                Hoddie and Tshirt
              </h2>
              <div className="flex flex-row w-full gap-x-[5px] items-center justify-start mt-[12px]">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_360_352)">
                    <path
                      d="M6.23003 14.0339C6.04993 14.0353 5.87135 14.0008 5.70474 13.9324C5.53814 13.864 5.38685 13.7631 5.25972 13.6355L1.28472 9.66048C1.15024 9.52574 1.04535 9.36444 0.976748 9.18687C0.908143 9.0093 0.87733 8.81938 0.886279 8.62923C0.909537 8.2434 1.07683 7.88038 1.35503 7.61204L7.50034 1.46204C7.64319 1.31153 7.81562 1.19219 8.0068 1.11152C8.19799 1.03085 8.40379 0.990598 8.61128 0.993291L12.4925 1.09173C12.8449 1.09907 13.1804 1.24389 13.4274 1.49527C13.6743 1.74664 13.8133 2.08463 13.8144 2.43704L13.9128 6.3136C13.9145 6.52164 13.8738 6.72783 13.7932 6.91963C13.7126 7.11143 13.5938 7.28482 13.4441 7.42923L7.30815 13.5933C7.04147 13.8738 6.67748 14.0416 6.29097 14.062L6.23003 14.0339ZM5.92534 12.9745C5.9683 13.0169 6.01977 13.0497 6.07633 13.0707C6.13289 13.0917 6.19326 13.1005 6.25347 13.0964C6.40042 13.086 6.53864 13.0227 6.64253 12.9183L12.7972 6.7636C12.8539 6.70901 12.899 6.64347 12.9296 6.57095C12.9602 6.49843 12.9758 6.42044 12.9753 6.34173L12.8769 2.46048C12.8769 2.34983 12.833 2.24372 12.7547 2.16548C12.6765 2.08724 12.5704 2.04329 12.4597 2.04329L8.57847 1.94485C8.49987 1.94522 8.42212 1.96116 8.34972 1.99173C8.27731 2.0223 8.21167 2.06691 8.15659 2.12298L2.0019 8.27767C1.89745 8.38156 1.83417 8.51977 1.82378 8.66673C1.81973 8.72693 1.8285 8.78731 1.84951 8.84387C1.87052 8.90043 1.90329 8.95189 1.94565 8.99485L5.92534 12.9745Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.5"
                    />
                    <circle cx="10.125" cy="4.875" r="1.125" stroke="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_360_352">
                      <rect width="15" height="15" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p className="w-[43px] h-[21px] font-semibold text-[14px] text-black text-start">
                  Price :
                </p>
                <p className="text-[#FF6300] w-[51px] h-[21px] font-semibold text-[14px] text-start">
                  ₹ 8983
                </p>
                <p className="w-[45px] h-[18px] font-medium text-[12px] text-start text-black line-through">
                  ₹ 670
                </p>
              </div>
              <p className="w-[286px] h-[132px] font-regular text-[12px] leading-[22px] text-start text-black mt-[15px]">
                This is product and can be the more popular.{"..."}
              </p>
              <div className="flex flex-row w-full h-[42px] items-center justify-start gap-x-[12px] mt-[26px]">
                <button className="w-[124px] h-[42px] bg-[#FF6300] flex items-center justify-center gap-x-[10px] rounded-[5px]">
                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_360_361)">
                      <path
                        d="M6.46123 13.2071C5.27767 13.2071 4.31479 14.17 4.31479 15.3536C4.31479 16.5371 5.27767 17.5 6.46123 17.5C7.64478 17.5 8.60767 16.5371 8.60767 15.3536C8.60767 14.17 7.64475 13.2071 6.46123 13.2071ZM6.46123 16.2122C5.98772 16.2122 5.60266 15.8271 5.60266 15.3536C5.60266 14.8801 5.98772 14.495 6.46123 14.495C6.9345 14.495 7.31979 14.8801 7.31979 15.3536C7.31979 15.8271 6.93473 16.2122 6.46123 16.2122ZM12.8147 13.2071C11.6311 13.2071 10.6682 14.17 10.6682 15.3536C10.6682 16.5371 11.6311 17.5 12.8147 17.5C13.9982 17.5 14.9611 16.5371 14.9611 15.3536C14.9611 14.17 13.9982 13.2071 12.8147 13.2071ZM12.8147 16.2122C12.3411 16.2122 11.9561 15.8271 11.9561 15.3536C11.9561 14.8801 12.3411 14.495 12.8147 14.495C13.2882 14.495 13.6732 14.8801 13.6732 15.3536C13.6732 15.8271 13.2882 16.2122 12.8147 16.2122ZM16.5383 4.69267C16.478 4.61685 16.4013 4.5556 16.3141 4.5135C16.2268 4.47139 16.1312 4.44952 16.0343 4.4495H4.75911L4.17377 1.49127C4.1487 1.36463 4.08613 1.24845 3.99419 1.15781C3.90225 1.06717 3.78519 1.00627 3.6582 0.983003L1.08247 0.51079C0.731983 0.446177 0.397131 0.678233 0.332949 1.02809C0.268768 1.37795 0.500359 1.71344 0.850252 1.77762L2.9954 2.17084L4.88511 11.7222C4.94478 12.0238 5.20944 12.2412 5.5168 12.2412H14.5318C14.8317 12.2412 15.0916 12.0346 15.1592 11.742L16.6617 5.2383C16.6835 5.14393 16.6838 5.04584 16.6624 4.95137C16.641 4.85689 16.5986 4.76846 16.5383 4.69267ZM14.0197 10.9534H6.04566L5.01387 5.73757H15.2244L14.0197 10.9534Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_360_361">
                        <rect
                          width="17"
                          height="17"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <p className="w-[67px] h-[18px] text-white font-medium text-[12px]">
                    Start Order
                  </p>
                </button>
                <button className="w-[123px] h-[42px] bg-white flex items-center justify-center gap-x-[10px] rounded-[5px] border">
                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_360_369)">
                      <path
                        d="M7.08301 10.4167L14.8747 2.625"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.8747 2.625L10.2706 15.375C10.2395 15.4428 10.1896 15.5003 10.1268 15.5406C10.064 15.5809 9.99101 15.6023 9.91641 15.6023C9.84181 15.6023 9.76878 15.5809 9.706 15.5406C9.64322 15.5003 9.59332 15.4428 9.56225 15.375L7.08308 10.4167L2.12474 7.9375C2.05693 7.90642 1.99946 7.85653 1.95917 7.79375C1.91888 7.73096 1.89746 7.65793 1.89746 7.58333C1.89746 7.50873 1.91888 7.4357 1.95917 7.37292C1.99946 7.31014 2.05693 7.26024 2.12474 7.22917L14.8747 2.625Z"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_360_369">
                        <rect
                          width="17"
                          height="17"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <p
                    className="w-[76px] h-[18px] text-black font-medium text-[12px]"
                    onClick={toggleNextButton}
                  >
                    Send Inquiry
                  </p>
                </button>
              </div>
            </div>
          </div>
          
          <div className="w-[610px] h-[316px] bg-white rounded-[10px] flex flex-row p-[20px] border gap-x-[22px]">
            <div className="flex flex-col w-[228px] h-full">
              <p className="w-[59px] h-[27px] bg-[#FF6300] rounded-[5px] flex items-center justify-center text-center font-semibold text-white text-[15px]">
                New
              </p>
              <div className="flex items-center justify-center w-full h-full">
                <img
                  src={require("../../assets/WebFront/BestDeal/image 244.png")}
                  alt=""
                  className="w-[198px] h-[198px]"
                />
              </div>
            </div>

            <div className="flex flex-col">
              <h2 className="w-[239px] h-[27px] text-start text-black font-semibold text-[18px]">
                M & H Hoodies For Women
              </h2>
              <div className="flex flex-row w-full gap-x-[5px] items-center justify-start mt-[12px]">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_360_352)">
                    <path
                      d="M6.23003 14.0339C6.04993 14.0353 5.87135 14.0008 5.70474 13.9324C5.53814 13.864 5.38685 13.7631 5.25972 13.6355L1.28472 9.66048C1.15024 9.52574 1.04535 9.36444 0.976748 9.18687C0.908143 9.0093 0.87733 8.81938 0.886279 8.62923C0.909537 8.2434 1.07683 7.88038 1.35503 7.61204L7.50034 1.46204C7.64319 1.31153 7.81562 1.19219 8.0068 1.11152C8.19799 1.03085 8.40379 0.990598 8.61128 0.993291L12.4925 1.09173C12.8449 1.09907 13.1804 1.24389 13.4274 1.49527C13.6743 1.74664 13.8133 2.08463 13.8144 2.43704L13.9128 6.3136C13.9145 6.52164 13.8738 6.72783 13.7932 6.91963C13.7126 7.11143 13.5938 7.28482 13.4441 7.42923L7.30815 13.5933C7.04147 13.8738 6.67748 14.0416 6.29097 14.062L6.23003 14.0339ZM5.92534 12.9745C5.9683 13.0169 6.01977 13.0497 6.07633 13.0707C6.13289 13.0917 6.19326 13.1005 6.25347 13.0964C6.40042 13.086 6.53864 13.0227 6.64253 12.9183L12.7972 6.7636C12.8539 6.70901 12.899 6.64347 12.9296 6.57095C12.9602 6.49843 12.9758 6.42044 12.9753 6.34173L12.8769 2.46048C12.8769 2.34983 12.833 2.24372 12.7547 2.16548C12.6765 2.08724 12.5704 2.04329 12.4597 2.04329L8.57847 1.94485C8.49987 1.94522 8.42212 1.96116 8.34972 1.99173C8.27731 2.0223 8.21167 2.06691 8.15659 2.12298L2.0019 8.27767C1.89745 8.38156 1.83417 8.51977 1.82378 8.66673C1.81973 8.72693 1.8285 8.78731 1.84951 8.84387C1.87052 8.90043 1.90329 8.95189 1.94565 8.99485L5.92534 12.9745Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.5"
                    />
                    <circle cx="10.125" cy="4.875" r="1.125" stroke="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_360_352">
                      <rect width="15" height="15" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p className="w-[43px] h-[21px] font-semibold text-[14px] text-black text-start">
                  Price :
                </p>
                <p className="text-[#FF6300] w-[51px] h-[21px] font-semibold text-[14px] text-start">
                  ₹ 3,000
                </p>
                <p className="w-[45px] h-[18px] font-medium text-[12px] text-start text-black line-through">
                  ₹ 5,000
                </p>
              </div>
              <p className="w-[286px] h-[132px] font-regular text-[12px] leading-[22px] text-start text-black mt-[15px]">
                Cozy and versatile, hoodies are the ultimate casual wear staple.
                Perfect for layering or as a standalone piece, they offer both
                comfort and style, featuring soft materials, a hood for extra
                warmth, and often a kangaroo pocket for convenience.
              </p>
              <div className="flex flex-row w-full h-[42px] items-center justify-start gap-x-[12px] mt-[26px]">
                <button className="w-[124px] h-[42px] bg-[#FF6300] flex items-center justify-center gap-x-[10px] rounded-[5px]">
                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_360_361)">
                      <path
                        d="M6.46123 13.2071C5.27767 13.2071 4.31479 14.17 4.31479 15.3536C4.31479 16.5371 5.27767 17.5 6.46123 17.5C7.64478 17.5 8.60767 16.5371 8.60767 15.3536C8.60767 14.17 7.64475 13.2071 6.46123 13.2071ZM6.46123 16.2122C5.98772 16.2122 5.60266 15.8271 5.60266 15.3536C5.60266 14.8801 5.98772 14.495 6.46123 14.495C6.9345 14.495 7.31979 14.8801 7.31979 15.3536C7.31979 15.8271 6.93473 16.2122 6.46123 16.2122ZM12.8147 13.2071C11.6311 13.2071 10.6682 14.17 10.6682 15.3536C10.6682 16.5371 11.6311 17.5 12.8147 17.5C13.9982 17.5 14.9611 16.5371 14.9611 15.3536C14.9611 14.17 13.9982 13.2071 12.8147 13.2071ZM12.8147 16.2122C12.3411 16.2122 11.9561 15.8271 11.9561 15.3536C11.9561 14.8801 12.3411 14.495 12.8147 14.495C13.2882 14.495 13.6732 14.8801 13.6732 15.3536C13.6732 15.8271 13.2882 16.2122 12.8147 16.2122ZM16.5383 4.69267C16.478 4.61685 16.4013 4.5556 16.3141 4.5135C16.2268 4.47139 16.1312 4.44952 16.0343 4.4495H4.75911L4.17377 1.49127C4.1487 1.36463 4.08613 1.24845 3.99419 1.15781C3.90225 1.06717 3.78519 1.00627 3.6582 0.983003L1.08247 0.51079C0.731983 0.446177 0.397131 0.678233 0.332949 1.02809C0.268768 1.37795 0.500359 1.71344 0.850252 1.77762L2.9954 2.17084L4.88511 11.7222C4.94478 12.0238 5.20944 12.2412 5.5168 12.2412H14.5318C14.8317 12.2412 15.0916 12.0346 15.1592 11.742L16.6617 5.2383C16.6835 5.14393 16.6838 5.04584 16.6624 4.95137C16.641 4.85689 16.5986 4.76846 16.5383 4.69267ZM14.0197 10.9534H6.04566L5.01387 5.73757H15.2244L14.0197 10.9534Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_360_361">
                        <rect
                          width="17"
                          height="17"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <p className="w-[67px] h-[18px] text-white font-medium text-[12px]">
                    Start Order
                  </p>
                </button>
                <button className="w-[123px] h-[42px] bg-white flex items-center justify-center gap-x-[10px] rounded-[5px] border">
                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_360_369)">
                      <path
                        d="M7.08301 10.4167L14.8747 2.625"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.8747 2.625L10.2706 15.375C10.2395 15.4428 10.1896 15.5003 10.1268 15.5406C10.064 15.5809 9.99101 15.6023 9.91641 15.6023C9.84181 15.6023 9.76878 15.5809 9.706 15.5406C9.64322 15.5003 9.59332 15.4428 9.56225 15.375L7.08308 10.4167L2.12474 7.9375C2.05693 7.90642 1.99946 7.85653 1.95917 7.79375C1.91888 7.73096 1.89746 7.65793 1.89746 7.58333C1.89746 7.50873 1.91888 7.4357 1.95917 7.37292C1.99946 7.31014 2.05693 7.26024 2.12474 7.22917L14.8747 2.625Z"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_360_369">
                        <rect
                          width="17"
                          height="17"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <p
                    className="w-[76px] h-[18px] text-black font-medium text-[12px]"
                    onClick={toggleNextButton}
                  >
                    Send Inquiry
                  </p>
                </button>
              </div>
            </div>
          </div> 
        </div>
      {/* })} */}

        {showForm2 && selectedProduct && (
          <>
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-[10px] w-[869px] h-[657px] flex flex-col">
                <div className="w-full h-[202px] bg-[#F8F8F8] rounded-t-[10px] pt-[24px] px-[40px] flex flex-col">
                  <p className="w-[125px] h-[24px] font-semibold text-[16px]">
                    Product Inquiry
                  </p>
                  <hr className="w-[184px] h-[3px] rounded-full bg-[#FF6300] mt-[13px]" />

                  <div className="mt-[18px] flex flex-row gap-x-[21px]">
                    <div className="w-[118px] h-[98px] bg-white flex items-center justify-center rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                      <img
                        src={selectedProduct?.images[0]}
                        alt=""
                        className="w-[48px] h-[60px]"
                      />
                    </div>

                    <div className="w-full flex justify-between">
                      <div className="flex flex-col gap-y-[11px] text-start items-start justify-center">
                        <p className="w-[307px] h-[21px] font-semibold text-[14px]">
                          {selectedProduct?.productTitle}
                        </p>
                        <p className="text-[12px] font-medium">
                          Seller : {selectedProduct?.storeName}
                        </p>
                      </div>

                      <div className="flex flex-col gap-y-[9px] justify-center items-end">
                        <div className="w-[55px] h-[18px] font-medium text-[12px] gap-x-[5px] flex items-center justify-end">
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.30671 18.7119C8.06657 18.7138 7.82847 18.6678 7.60633 18.5766C7.38418 18.4853 7.18246 18.3507 7.01296 18.1806L1.71296 12.8806C1.53366 12.701 1.39381 12.4859 1.30233 12.2492C1.21086 12.0124 1.16977 11.7592 1.18171 11.5056C1.21272 10.9912 1.43577 10.5072 1.80671 10.1494L10.0005 1.94939C10.1909 1.7487 10.4208 1.58958 10.6757 1.48203C10.9307 1.37447 11.2051 1.3208 11.4817 1.32439L16.6567 1.45564C17.1265 1.46542 17.5738 1.65852 17.9031 1.99369C18.2325 2.32885 18.4177 2.77951 18.4192 3.24939L18.5505 8.41814C18.5527 8.69552 18.4984 8.97044 18.391 9.22617C18.2835 9.48191 18.1251 9.71309 17.9255 9.90564L9.74421 18.1244C9.38863 18.4984 8.90331 18.7221 8.38796 18.7494L8.30671 18.7119ZM7.90046 17.2994C7.95774 17.3559 8.02635 17.3996 8.10177 17.4276C8.17719 17.4556 8.25769 17.4673 8.33796 17.4619C8.5339 17.448 8.71818 17.3637 8.85671 17.2244L17.063 9.01814C17.1386 8.94535 17.1986 8.85795 17.2394 8.76126C17.2803 8.66457 17.301 8.56059 17.3005 8.45564L17.1692 3.28064C17.1692 3.13311 17.1106 2.99163 17.0063 2.88731C16.902 2.78299 16.7605 2.72439 16.613 2.72439L11.438 2.59314C11.3332 2.59363 11.2295 2.61487 11.133 2.65564C11.0364 2.6964 10.9489 2.75588 10.8755 2.83064L2.66921 11.0369C2.52993 11.1754 2.44556 11.3597 2.43171 11.5556C2.42631 11.6359 2.438 11.7164 2.46601 11.7918C2.49403 11.8672 2.53772 11.9359 2.59421 11.9931L7.90046 17.2994Z"
                              fill="black"
                              stroke="black"
                              stroke-width="0.5"
                            />
                            <circle
                              cx="13.5"
                              cy="6.5"
                              r="1.5"
                              stroke="black"
                              stroke-width="1.5"
                            />
                          </svg>
                          <p className="">Price :</p>
                        </div>
                        <p className="w-[102px] h-[21px] font-semibold text-[14px]">
                          ₹ {selectedProduct?.maxPrice} /{" "}
                          {selectedProduct?.productType
                            ? selectedProduct.productType
                            : "Unit"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="px-[40px] w-[869px] h-[455px] pt-[46px]">
                  <div className="flex flex-row gap-x-[22px]">
                    <div className="gap-y-[10px] flex flex-col">
                      <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                        Product Quantity
                      </p>
                      <input
                        type="text"
                        value={inquiryQuantity}
                        onChange={(e) => setInquiryQuantity(e.target.value)}
                        placeholder="Enter product quantity"
                        className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px]"
                      />
                    </div>

                    <div className="gap-y-[10px] flex flex-col">
                      <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                        Email ID
                      </p>
                      <input
                        type="text"
                        value={inquiryEmail}
                        onChange={(e) => setInquiryEmail(e.target.value)}
                        placeholder="Enter your email ID"
                        className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px]"
                      />
                    </div>

                    <div className="gap-y-[10px] flex flex-col">
                      <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                        Contact No.
                      </p>
                      <input
                        type="text"
                        value={inquiryContact}
                        onChange={(e) => setInquiryContact(e.target.value)}
                        placeholder="Enter your contact no."
                        className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px]"
                      />
                    </div>
                  </div>

                  <div className="gap-y-[10px] flex flex-col mt-[28px]">
                    <p className="w-[50px] h-[21px] font-semibold text-[14px] text-black">
                      Inquiry
                    </p>
                    <textarea
                      name="Inquiry"
                      id="Inquiry"
                      rows={5}
                      value={inquiryContent}
                      onChange={(e) => setInquiryContent(e.target.value)}
                      placeholder="Tell us what else do you want to know about the product"
                      className="w-[789px] h-[149px] p-[10px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
                    ></textarea>
                  </div>

                  <div className="flex items-center justify-center">
                    <button
                      className="w-[162px] h-[42px] bg-[#FF6300] font-semibold text-[14px] rounded-[5px] text-white mt-[50px]"
                      onClick={toggleSubmitButton}
                    >
                      Send Inquiry
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {showForm3 && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-[10px] w-[869px] h-[434px] flex flex-col pt-[65px] pb-[51px] items-center justify-center gap-y-[32px]">
              <p className="w-[98px] h-[98px] bg-[#0097B2] rounded-full flex items-center justify-center">
                <svg
                  width="60"
                  height="46"
                  viewBox="0 0 60 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.1983 42.8495C21.5731 43.477 20.6874 44 19.9059 44C19.1245 44 18.2388 43.4509 17.5876 42.8233L3 28.1805L7.63676 23.5261L19.932 35.868L52.4414 3L57 7.73278L22.1983 42.8495Z"
                    fill="white"
                    stroke="white"
                    stroke-width="3"
                  />
                </svg>
              </p>
              <h3 className="w-[113px] h-[24px] font-semibold text-[16px] text-black text-start">
                Inquiry Sent !!
              </h3>
              <p className="w-[305px] h-[52px] font-medium text-[14px] text-black text-center">
                Your inquiry has been sent to the seller. We will notify you
                once the seller responds.
              </p>
              <button
                className="w-[162px] h-[42px] bg-[#FF6300] rounded-[5px] text-white font-semibold text-[14px]"
                onClick={handleViewAllInquiries}
              >
                View All Inquiries
              </button>
            </div>
          </div>
        )}
      </div>
    </div>

    {/* <WebStoreProducts/> */}
    </>
  );
};

export default BestDealsSection;
